import { ComponentType } from 'react';
import {
  AdminIcon,
  ForumModeratorIcon,
  BlogWriterIcon,
  BlogEditorIcon,
} from '@wix/members-area-commons-ts';
import { RoleId } from '@wix/members-domain-ts';

interface RoleIcons {
  [key: string]: ComponentType;
}

const roleIcons: RoleIcons = {
  [RoleId.ADMIN]: AdminIcon,
  [RoleId.SET_BLOG_EDITOR]: BlogEditorIcon,
  [RoleId.SET_FORUM_MODERATOR]: ForumModeratorIcon,
  [RoleId.SET_BLOG_WRITER]: BlogWriterIcon,
};

export default roleIcons;
